<template>
  <div class="promo-app">
    <Home></Home>
  </div>
</template>

<script>
// @ is an alias to /src
import store from "./store/store";
import Home from "@/components/Home.vue";
//import Tabs from "@/components/leagues-tabs-component.vue";

export default {
  name: "Promo",
  components: {
    Home
  },
  mounted() {
    Promise.all([
      this.loadPromoContent(),
      this.loadPromoConfig().then(() => store.dispatch("getApiData"))
    ]).then(() => {
      store.commit("setLoaded");
    });
  },
  methods: {
    loadPromoConfig() {
      return new Promise((resolve, reject) => {
        if (window.clientConfig && window.clientConfig.promoConfig) {
          // mobile
          store.commit("setPromoConfig", {
            ...window.clientConfig.promoConfig,
            ...window.siteConfig,
            vanilla6:
              window.clientConfig.vnPage === undefined
                ? false
                : window.clientConfig.vnPage.useResponsiveFeatures
          });
          resolve();
        } else if (window.bwin && window.bwin.config.promoConfig) {
          // desktop
          store.commit("setPromoConfig", {
            ...window.bwin.config.promoConfig,
            ...window.siteConfig,
            vanilla6:
              !window.clientConfig || window.clientConfig.vnPage === undefined
                ? false
                : window.clientConfig.vnPage.useResponsiveFeatures
          });
          resolve();
        } else {
          reject();
        }
      });
    },
    loadPromoContent() {
      if (typeof window.promoContent !== "undefined") {
        store.commit("setPromoContent", window.promoContent);
      } else {
        console.error("window.promoContent not found");
      }
    }
  }
};
</script>

<style lang="scss">
.promo-app {
  text-align: center;
}
</style>
